// Supported primitive types
export enum PrimitiveType {
  STRING = 'string',
  NUMBER = 'number',
  BOOLEAN = 'boolean',
}

export type TPrimitiveValue = string | number | boolean;
// Supported property kinds
export enum SupportedPropertyType {
  STRING = 'string',
  NUMBER = 'number',
  BOOLEAN = 'boolean',
  ENUM = 'enum',
  ARRAY = 'array',
  OBJECT = 'object',
}

export type TSchemaObject = {
  id: string;
  name: string;
  type: SupportedPropertyType;
  required: boolean;
  allowNull?: boolean;
  additionalProperties?: boolean;
  description?: string;
  title?: string;
  // enum specifics
  enumBase?: PrimitiveType;
  enumValues?: TPrimitiveValue[];
  // array specifics
  items?: {
    // either a primitive (by kind) or an object with nested properties
    type: SupportedPropertyType;
    // if items.kind === "object", use nestedProperties and if additional properties are allowed in the object.
    nestedProperties?: TSchemaObject[];
    additionalProperties?: boolean;
  };
  // object specifics
  properties?: TSchemaObject[]; // nested properties if kind === "object"
};

export type TJsonSchemaDocument = {
  name: string;
  root: TSchemaObject;
};
